export default __webpack_public_path__ + "static/media/delphi.08ba488f.png";